import mathsBuddyIcon from '@images/maths-buddy-icon.png'
import bookIcon from '@images/book-icon.png'
import readingReggieIcon from '@images/reading-reggie-icon.png'
import writingLegendsIcon from '@images/writing-legend-standing.png'

export const PRINTABLES_TAB_READING = 'printables-tab-reading'
export const PRINTABLES_TAB_MATHS = 'printables-tab-maths'
export const PRINTABLES_TAB_READER = 'printables-tab-reader'
export const PRINTABLES_TAB_WRITING = 'printables-tab-writing'

export const PRINTABLES_SUB_TYPE_READING = 'Reading'
export const PRINTABLES_SUB_TYPE_MATHS = 'Maths'
export const PRINTABLES_SUB_TYPE_WRITING = 'Writing'

export const PRINTABLES_CATEGORY_READER = 'reader'
export const PRINTABLES_CATEGORY_GENERAL = 'general'

export interface PrintablesTabMeta {
  id:
    | typeof PRINTABLES_TAB_READING
    | typeof PRINTABLES_TAB_MATHS
    | typeof PRINTABLES_TAB_READER
    | typeof PRINTABLES_TAB_WRITING
  imageUrl: string
  imageAlt: string
  subscriptionType:
    | typeof PRINTABLES_SUB_TYPE_READING
    | typeof PRINTABLES_SUB_TYPE_MATHS
    | typeof PRINTABLES_SUB_TYPE_WRITING
  category: typeof PRINTABLES_CATEGORY_GENERAL | typeof PRINTABLES_CATEGORY_READER
  quickFilterId: 'Reading' | 'Reader' | 'Maths' | 'Writing'
  titleKey: string
}

export const READING: PrintablesTabMeta = {
  id: PRINTABLES_TAB_READING,
  imageUrl: readingReggieIcon,
  imageAlt: 'Readingeggs avatar',
  subscriptionType: PRINTABLES_SUB_TYPE_READING,
  category: PRINTABLES_CATEGORY_GENERAL,
  quickFilterId: 'Reading',
  titleKey: 'printables.reading',
}

export const READER: PrintablesTabMeta = {
  id: PRINTABLES_TAB_READER,
  imageUrl: bookIcon,
  imageAlt: 'Stack of books',
  subscriptionType: PRINTABLES_SUB_TYPE_READING,
  category: PRINTABLES_CATEGORY_READER,
  quickFilterId: 'Reader',
  titleKey: 'printables.readers',
}

export const MATHS: PrintablesTabMeta = {
  id: PRINTABLES_TAB_MATHS,
  imageUrl: mathsBuddyIcon,
  imageAlt: 'Mathseeds avatar',
  subscriptionType: PRINTABLES_SUB_TYPE_MATHS,
  category: PRINTABLES_CATEGORY_GENERAL,
  quickFilterId: 'Maths',
  titleKey: 'printables.maths',
}

export const WRITING: PrintablesTabMeta = {
  id: PRINTABLES_TAB_WRITING,
  imageUrl: writingLegendsIcon,
  imageAlt: 'Writing Legends avatar',
  subscriptionType: PRINTABLES_SUB_TYPE_WRITING,
  category: PRINTABLES_CATEGORY_GENERAL,
  quickFilterId: 'Writing',
  titleKey: 'printables.writing',
}

export const PRINTABLES_TABS: PrintablesTabMeta[] = [READING, READER, MATHS, WRITING]
